export default __webpack_public_path__ + "static/media/user-avatar.7faa71ab.png";